(() => {
  const TIME_ZONE = 'Europe/Copenhagen';
  const DAY_NAMES = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
  const MONTH_NAMES = ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];

  const getCopenhagenParts = (date) => {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(date);

    return Object.fromEntries(parts.filter((part) => part.type !== 'literal').map((part) => [part.type, Number(part.value)]));
  };

  const copenhagenOffset = (date) => {
    const parts = getCopenhagenParts(date);
    const representedAsUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
    return representedAsUtc - date.getTime();
  };

  const fromCopenhagen = (year, month, day, hour = 0, minute = 0) => {
    let timestamp = Date.UTC(year, month - 1, day, hour, minute);
    timestamp -= copenhagenOffset(new Date(timestamp));
    return new Date(timestamp);
  };

  const addCalendarDays = (date, days) => {
    const parts = getCopenhagenParts(date);
    const calendar = new Date(Date.UTC(parts.year, parts.month - 1, parts.day + days));
    return fromCopenhagen(calendar.getUTCFullYear(), calendar.getUTCMonth() + 1, calendar.getUTCDate(), parts.hour);
  };

  const getWeekday = (date) => {
    const parts = getCopenhagenParts(date);
    return new Date(Date.UTC(parts.year, parts.month - 1, parts.day)).getUTCDay();
  };

  const nextProcessingDay = (date) => {
    let result = addCalendarDays(date, 1);
    while (getWeekday(result) === 0 || getWeekday(result) === 6) result = addCalendarDays(result, 1);
    return result;
  };

  const nextDeliveryDay = (date) => {
    let result = addCalendarDays(date, 1);
    while (getWeekday(result) === 0) result = addCalendarDays(result, 1);
    return result;
  };

  const cutoffTime = (date) => (getWeekday(date) === 5 ? { hour: 12, minute: 0 } : { hour: 14, minute: 30 });

  const cutoffForDate = (date) => {
    const parts = getCopenhagenParts(date);
    const cutoff = cutoffTime(date);
    return fromCopenhagen(parts.year, parts.month, parts.day, cutoff.hour, cutoff.minute);
  };

  const getProcessingCutoff = (now) => {
    const weekday = getWeekday(now);

    if (weekday === 0 || weekday === 6) {
      return cutoffForDate(nextProcessingDay(now));
    }

    const todayCutoff = cutoffForDate(now);
    return now < todayCutoff ? todayCutoff : cutoffForDate(nextProcessingDay(now));
  };

  const formatDeliveryRange = (earliestDate, latestDate) => {
    const earliest = getCopenhagenParts(earliestDate);
    const latest = getCopenhagenParts(latestDate);
    const earliestWeekday = new Date(Date.UTC(earliest.year, earliest.month - 1, earliest.day)).getUTCDay();
    const latestWeekday = new Date(Date.UTC(latest.year, latest.month - 1, latest.day)).getUTCDay();
    const sameMonth = earliest.year === latest.year && earliest.month === latest.month;
    const earliestMonth = sameMonth ? '' : ` ${MONTH_NAMES[earliest.month - 1]}`;

    return `${DAY_NAMES[earliestWeekday]} d. ${earliest.day}.${earliestMonth} eller senest ${DAY_NAMES[latestWeekday]} d. ${latest.day}. ${MONTH_NAMES[latest.month - 1]}`;
  };

  const update = () => {
    const now = new Date();
    const processingCutoff = getProcessingCutoff(now);
    const earliestDelivery = nextDeliveryDay(processingCutoff);
    const latestDelivery = nextDeliveryDay(earliestDelivery);

    document.querySelectorAll('[data-delivery-countdown]').forEach((countdown) => {
      const estimate = countdown.querySelector('[data-delivery-estimate]');
      const nextEstimate = formatDeliveryRange(earliestDelivery, latestDelivery);
      if (estimate && estimate.textContent !== nextEstimate) estimate.textContent = nextEstimate;
    });
  };

  update();
  window.setInterval(update, 60000);

  const observer = new MutationObserver((mutations) => {
    const deliveryEstimateAdded = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === 1 &&
          (node.matches?.('[data-delivery-countdown]') || node.querySelector?.('[data-delivery-countdown]'))
      )
    );

    if (deliveryEstimateAdded) update();
  });

  if (document.body) observer.observe(document.body, { childList: true, subtree: true });
})();
